import React from "react";
import CommonIcon from "../helpers/icons";
import { CreateAccountapi, verifyEmail } from "../../action/createaccountapi";
import { resetpassword, VerifyInviteFromLink } from "../../action/UsersApi";
import withRouter from "../custom/withRouter";
import { connect } from "react-redux";
import { Password } from "@mui/icons-material";
import { Autocomplete, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import API from "../helpers/endpointservice";
// import parsePhoneNumber, { parsePhoneNumberFromString } from 'libphonenumber-js';
import { parsePhoneNumberFromString } from "libphonenumber-js/max";
import Countries from "../helpers/countries";
import Actions from "../../action/api";
class SetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: localStorage.getItem("firstnameTAC"),
      lastName: localStorage.getItem("lastnameTAC"),
      email: "",
      phone: "",
      nameError: "",
      lastNameError: "",
      emailError: "",
      phoneError: "",
      organizationName: "",
      organizationNameError: "",
      password: "",
      conformPassword: "",
      conformPasswordError: "",
      passwordError: "",
      showPassword: false,
      showConformPassword: false,
      select: "91",
      isChecked: false,
      countryData: [],
      decide: "false",
      decide1: "",
      primaryPhoneCode: "",
      phoneerror: "",
    };
    this.initialCall();
  }

  validatePhoneNumberByDialCode = (countryCode, phoneNumber) => {
    try {
      const fullNumber = `${countryCode}${phoneNumber}`;
      const phone = parsePhoneNumberFromString(fullNumber);
      return phone && phone.isValid();
    } catch (error) {
      console.error("Validation failed:", error.message);
      return false;
    }
  };

  componentDidMount = async () => {
    // this.getCountries();
    this.setState({ countryData: Countries });

    // const currentUrl = window.location.href;
    // const url = new URL(currentUrl);
    // const queryParams = new URLSearchParams(url.search);

    // const realmname = queryParams.get('realmname');
    // this.state.organizationName = queryParams.get('realmname');
    // this.state.email = queryParams.get('email');
    // const email = queryParams.get('email');
    // const id = queryParams.get('id');
    // console.log(realmname, email, id);
    // let data = {
    //     "tenantName": realmname,
    //     "email": email,
    //     "guid": id
    // }
    // await this.props.dispatch(VerifyInviteFromLink(data))
    // console.log(this.props.VerifyInviteFromLink);
    // if(this.props.VerifyInviteFromLink?.status=="Fail"){
    //     window.location.href="/alreadyjoined"
    // }
    // VerifyInviteFromLink(data)
  };

  decryptText = async (cipherText, base64Key, base64Iv) => {
    try {
      // Convert URL-safe base64 → normal base64
      cipherText = cipherText.replace(/-/g, "+").replace(/_/g, "/");
      while (cipherText.length % 4 !== 0) cipherText += "=";

      const keyBytes = Uint8Array.from(atob(base64Key), (c) => c.charCodeAt(0));
      const ivBytes = Uint8Array.from(atob(base64Iv), (c) => c.charCodeAt(0));
      const encryptedBytes = Uint8Array.from(atob(cipherText), (c) =>
        c.charCodeAt(0)
      );

      // Import AES key
      const cryptoKey = await window.crypto.subtle.importKey(
        "raw",
        keyBytes,
        { name: "AES-CBC" },
        false,
        ["decrypt"]
      );

      // Perform decryption
      const decryptedBuffer = await window.crypto.subtle.decrypt(
        { name: "AES-CBC", iv: ivBytes },
        cryptoKey,
        encryptedBytes
      );

      return new TextDecoder().decode(decryptedBuffer);
    } catch (error) {
      console.error("Decrypt failed:", error);
      return null;
    }
  };

  initialCall = async () => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const queryParams = new URLSearchParams(url.search);
    const encryptedData = queryParams.get("data");
    const AESKEY = process.env.REACT_APP_AES_KEY;
    const AESIV = process.env.REACT_APP_AES_IV;
    let decryptedJson = null;
    let decryptedData = await this.decryptText(encryptedData, AESKEY, AESIV);
    if (decryptedData) {
      decryptedJson = JSON.parse(decryptedData);
    }
    console.log(decryptedJson);
    const realmname = decryptedJson?.RealmName;
    this.state.organizationName = decryptedJson?.RealmName;
    this.state.email = decryptedJson?.Email;
    const email = decryptedJson?.Email;
    const id = decryptedJson?.Id;
    // const realmname = queryParams.get("realmname");
    // this.state.organizationName = queryParams.get("realmname");
    // this.state.email = queryParams.get("email");
    // const email = queryParams.get("email");
    // const id = queryParams.get("id");
    console.log(realmname, email, id);
    let data = {
      tenantName: realmname,
      email: email,
      guid: id,
    };
    await this.props
      .dispatch(VerifyInviteFromLink(data))
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
      });
    console.log(this.props.VerifyInviteFromLink);
    console.log(this.props.VerifyInviteFromLink?.user?.phoneNumber);
    if (this.props.VerifyInviteFromLink?.user?.phoneNumber) {
      const fullPhone = this.props.VerifyInviteFromLink.user.phoneNumber || "";
      this.setState({ phoneError: "", orgError: "" });
      let primaryPhoneCod = "";
      let primaryPhone = "";
      if (fullPhone.includes("-")) {
        [primaryPhoneCod, primaryPhone] = fullPhone.split("-");
      } else if (fullPhone.startsWith("+")) {
        primaryPhoneCod = fullPhone;
      } else {
        primaryPhone = fullPhone;
      }
      this.setState({
        phone: primaryPhone,
        primaryPhoneCode: primaryPhoneCod,
      });
    }

    this.setState({
      decide: this.props.VerifyInviteFromLink.status,
      decide1: this.props.VerifyInviteFromLink.status,
    });
  };

  handleValidate = async () => {
    if (this.state.password.trim() == "") {
      this.state.passwordError = "Password is missing.";
    } else {
      const regex = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
      if (regex.test(this.state.password)) {
        this.state.passwordError = "";
      } else {
        this.state.passwordError =
          "Include uppercase and lowercase letters, a number, and a special character (!@#$%^&*).";
      }
    }
    if (this.state.conformPassword == "") {
      this.state.conformPasswordError = "Confirm password is missing";
    } else {
      if (this.state.password != this.state.conformPassword) {
        this.state.conformPasswordError = "Password mismatch";
      } else {
        this.state.conformPasswordError = "";
      }
    }
    if (
      (this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null) ||
      this.state.phone !== ""
    ) {
      if (
        ((this.state.primaryPhoneCode !== "" ||
          this.state.primaryPhoneCode !== null) &&
          this.state.phone == "") ||
        ((this.state.primaryPhoneCode == "" ||
          this.state.primaryPhoneCode == null) &&
          this.state.phone !== "")
      ) {
        if (
          this.state.primaryPhoneCode !== "" &&
          this.state.primaryPhoneCode !== null &&
          this.state.phone == ""
        ) {
          this.setState({ phoneError: "Phone number is missing" });
        } else if (
          (this.state.primaryPhoneCode == "" ||
            this.state.primaryPhoneCode == null) &&
          this.state.phone !== ""
        ) {
          this.setState({ phoneError: "Country code is missing" });
        }
      } else {
        this.setState({ phoneError: "Country code is missing" });
      }

      if (
        this.state.primaryPhoneCode !== "" &&
        this.state.primaryPhoneCode !== null &&
        this.state.phone !== ""
      ) {
        let bool = this.validatePhoneNumberByDialCode(
          this.state.primaryPhoneCode,
          this.state.phone
        );
        if (!bool) {
          this.setState({ phoneError: "Invalid phone number" });
        } else {
          this.setState({ phoneError: "" });
        }
      }
    } else {
      this.setState({ phoneError: "" });
    }
  };
  handleSubmit = async () => {
    await this.handleValidate();
    let phonenumber = this.state.phone
      ? this.state.primaryPhoneCode + "-" + this.state.phone
      : "";
    const isChecked = this.state.isChecked === true;
    if (
      ((this.state.password != "" &&
        this.state.passwordError == "" &&
        this.state.phoneError == "") ||
        (localStorage.getItem("isSSOTAC") == "true" &&
          this.state.phoneError == "")) &&
      isChecked
    ) {
      let resetPasswordValues = {
        password: this.state.password ? this.state.password : "",
        tenantName: this.state.organizationName,
        email: this.state.email,
        firstName: "",
        lastName: "",
        phoneNumber: phonenumber,
        isSSO: localStorage.getItem("isSSOTAC") == "true" ? true : false,
      };
      if (localStorage.getItem("isSSOTAC") == "true") {
        this.props.dispatch(resetpassword(resetPasswordValues));
      } else {
        this.props.dispatch(resetpassword(resetPasswordValues));
      }
    }
  };
  togglePasswordVisibility = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  toggleConformPasswordVisibility = () => {
    this.setState({ showConformPassword: !this.state.showConformPassword });
  };

  navigate = () => {
    window.location.href = "/login";
  };
  handleChange = () => {
    this.setState({ isChecked: !this.state.isChecked });
  };

  getCountries = () => {
    Actions.GET(API.GET_COUNTRIES)
      .then((res) => {
        if (res.data) {
          const filteredData = res.data
            .filter(
              (item) => item.countryCode && item.countryCode.trim() !== ""
            )
            .map((item) => ({
              ...item,
              // optionally do more transformation here
            }));
          this.setState({ countryData: filteredData }, () => {
            console.log(this.state.countryData);
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    //  console.log(this.state.name);
    // console.log(this.state.isChecked);
    const { VerifyInviteFromLink } = this.props;
    // console.log(VerifyInviteFromLink?.status);
    return (
      <>
        {this.state.decide1 != "" ? (
          this.state.decide == "Success" ? (
            <div className="main">
              <div style={{ width: "100vw", height: "100vh" }}>
                <div className="tpcontent">
                  <div className="pl-3">
                    <CommonIcon fileName={"FlazlogoLogin"} />
                    &nbsp;
                  </div>
                </div>

                <div
                  className="submain1"
                  style={{
                    width: "100vw",
                    height: "calc(100vh - 50px)",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="form1"
                    style={{
                      padding: "20px",
                      height: "max-content",
                      margin: "auto",
                    }}
                  >
                    <div
                      style={{ textAlign: "left", paddingLeft: "01px" }}
                      className="w-100"
                    >
                      <h4
                        style={{
                          padding: "6px 0px 0px 20px",
                          fontWeight: "600",
                        }}
                        className="mt-0"
                      >
                        {this.state.organizationName.toUpperCase()}
                      </h4>
                      <label
                        style={{
                          paddingLeft: "20px",
                          fontSize: "14px",
                          fontWeight: "500px",
                          wordBreak: "break-word",
                        }}
                      >
                        Invited by {localStorage.getItem("invitenameTAC")} (
                        {localStorage.getItem("inviteemailTAC")})
                      </label>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      className="w-100"
                    >
                      <div
                        className="w-100 customHr mt-2 "
                        style={{
                          marginLeft: "10px",
                          marginRight: "10px",
                          borderColor: "#a2a4a5",
                        }}
                      ></div>
                    </div>
                    <div
                      className="w-100"
                      style={{
                        textAlign: "left",
                        paddingLeft: "20px",
                        marginTop: "10px",
                      }}
                    >
                      <label
                        className=""
                        style={{ fontSize: "16px", fontWeight: "bold" }}
                      >
                        Join our organization
                      </label>
                      <div className="pt-1 w-100">
                        <p className="mb-1" style={{ fontSize: "11px" }}>
                          A new Flaz account will be created for this email
                          address
                          <br />
                          <span style={{ fontWeight: "bold" }}>
                            {this.state.email}
                          </span>
                        </p>
                      </div>
                    </div>
                    <div className="input h-100 w-100">
                      <div
                        className="w-100"
                        style={{
                          display:
                            localStorage.getItem("isSSOTAC") == "true"
                              ? "none"
                              : "block",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                      >
                        <label className="label" style={{ fontSize: "14px" }}>
                          Password
                        </label>
                        <span className="isrequired">*</span>
                        <br />
                        <div
                          style={{
                            border: this.state.passwordError
                              ? "1px solid red"
                              : "1px solid #ebeaea",
                            paddingLeft: "5px",
                            display: "flex",
                          }}
                        >
                          <CommonIcon fileName={"Lockpassword"} /> &nbsp;
                          <input
                            id="password"
                            value={this.state.password}
                            type={this.state.showPassword ? "text" : "password"}
                            onChange={(e) =>
                              this.setState({ password: e.target.value })
                            }
                            placeholder="Password"
                            style={{
                              width: "100%",
                              height: "40px",
                              alignItems: "center",
                              border: "none",
                              outline: "none",
                              fontSize: "13px",
                              fontFamily: "Poppins",
                            }}
                          />
                          <button
                            className="border-none"
                            onClick={this.togglePasswordVisibility}
                          >
                            {!this.state.showPassword ? (
                              <CommonIcon fileName={"passwordvisible"} />
                            ) : (
                              <CommonIcon fileName={"passwordvisibleoff"} />
                            )}
                          </button>
                        </div>
                        <span className="error">
                          {this.state.passwordError
                            ? this.state.passwordError
                            : ""}
                        </span>
                      </div>
                      <div
                        className="w-100 d-flex"
                        style={{ paddingLeft: "20px", paddingRight: "20px" }}
                      >
                        <div className="w-100">
                          <label
                            className="label"
                            style={{ fontSize: "14px", color: "#342E37" }}
                          >
                            Phone Number{" "}
                          </label>
                          <br />
                          <div
                            style={{
                              border:
                                this.state.phoneError !== ""
                                  ? "1px solid red"
                                  : "1px solid #ebeaea",
                              display: "flex",
                              paddingLeft: "5px",
                            }}
                            className="w-100"
                          >
                            {/* <select className='noborder outline-none' value={this.state.select} onChange={(e) => this.setState({ select: e.target.value })}>
                                                            <option value='91'>+91</option>
                                                            <option value='65'>+65</option>
                                                            <option value='70'>+70</option>
                                                        </select> */}
                            <CommonIcon fileName={"flagicon"} /> &nbsp;
                            <Autocomplete
                              options={this.state.countryData}
                              getOptionLabel={(option) =>
                                option.countryCode.toString()
                              }
                              value={
                                this.state.countryData.find(
                                  (item) =>
                                    item.countryCode ===
                                    this.state.primaryPhoneCode
                                ) || null
                              }
                              onChange={(e, newValue) => {
                                this.setState({
                                  primaryPhoneCode: newValue?.countryCode ?? "",
                                });
                              }}
                              // renderOption={(props, option, { selected }) => (
                              //   <li {...props} key={option.id}>
                              //     {option.countryCode}
                              //   </li>
                              // )}
                              renderOption={(props, option) => {
                                const { key, ...optionProps } = props;
                                return (
                                  <Box
                                    key={option.id}
                                    component="li"
                                    sx={{
                                      "& > img": { mr: 1.5, flexShrink: 0 },
                                    }}
                                    {...optionProps}
                                  >
                                    <img
                                      loading="lazy"
                                      width="24"
                                      height="18"
                                      srcSet={`https://flagcdn.com/48x36/${option.code.toLowerCase()}.png 2x`}
                                      src={`https://flagcdn.com/24x18/${option.code.toLowerCase()}.png`}
                                      alt=""
                                    />
                                    {option.countryCode}
                                  </Box>
                                );
                              }}
                              filterOptions={(options, state) => {
                                const input = state.inputValue
                                  .replace("+", "")
                                  .trim()
                                  .toLowerCase();

                                return options.filter((option) => {
                                  const code =
                                    option.countryCode
                                      ?.replace("+", "")
                                      .toLowerCase() || "";
                                  const name =
                                    option.countryName?.toLowerCase() || "";

                                  // ✅ Match either country code or country name
                                  return (
                                    code.includes(input) || name.includes(input)
                                  );
                                });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  className="noborder outline-none"
                                  placeholder="Code"
                                  variant="standard" // or "outlined" if needed
                                  InputProps={{
                                    ...params.InputProps,
                                    disableUnderline: true, // removes underline
                                  }}
                                  sx={{
                                    "& .MuiAutocomplete-input::placeholder": {
                                      color: "rgba(117, 117, 117)",
                                      opacity: 1,
                                    },
                                  }}
                                />
                              )}
                              sx={{
                                width: 150,
                                "& .MuiInputBase-root": {
                                  border: "none",
                                  outline: "none",
                                  padding: "6px",
                                  paddingLeft: "2px",
                                  fontSize: "13px",
                                },
                              }}
                            />
                            <CommonIcon fileName={"phoneicon"} /> &nbsp;
                            <input
                              id="phone"
                              value={
                                this.state.phone != "" ? this.state.phone : ""
                              }
                              type="tel"
                              placeholder="Phone number"
                              // onChange={(e) => this.setState({ phone: e.target.value })}
                              onInput={(e) => {
                                const value = e.target.value;
                                // Restrict the value to only numeric characters
                                e.target.value = value.replace(/[^0-9]/g, "");
                                this.setState({ phone: e.target.value });
                              }}
                              style={{
                                width: "90%",
                                height: "40px",
                                alignItems: "center",
                                border: "none",
                                outline: "none",
                                fontSize: "13px",
                              }}
                            />
                          </div>
                          <span className="error">
                            {this.state.phoneError ? this.state.phoneError : ""}
                          </span>
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginTop: "10px",
                          marginBottom: "10px",
                          paddingLeft: "20px",
                          paddingRight: "20px",
                        }}
                        className="w-100"
                      >
                        <input
                          type="checkbox"
                          style={{
                            marginRight: "10px",
                            accentColor: "#226eb7",
                          }}
                          id="checkbox"
                          checked={this.state.isChecked} // Bind checked state
                          onChange={this.handleChange}
                        />
                        <label
                          style={{ fontSize: "12px", wordBreak: "break-word" }}
                        >
                          I agree to the{" "}
                          <span className="isblue">Terms of service</span> and{" "}
                          <span className="isblue">Privacy policies</span> of
                          Flaz.
                        </label>
                      </div>
                    </div>

                    <div className="ms-5 mt-1 mb-2">
                      <button
                        className={`createbtn w-100 `}
                        type=""
                        onClick={this.handleSubmit}
                        style={{
                          fontSize: "15px",
                          cursor: this.state.isChecked ? "pointer" : "none",
                        }}
                        disabled={!this.state.isChecked}
                      >
                        Sign up & Accept
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="main1">
              <div>
                <div className="tpcontent">
                  <div className="pl-3">
                    <CommonIcon fileName={"FlazlogoLogin"} />
                  </div>
                </div>

                <div
                  className="submain1"
                  style={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className="form "
                    style={{
                      height: "400px",
                      width: "600px",
                      marginTop: "-100px",
                      textAlign: "center",
                    }}
                  >
                    <h3 style={{ fontSize: "30px" }}>
                      Already joined this organization
                    </h3>
                    <label style={{ fontSize: "14px", marginTop: "20px" }}>
                      You are already a part of the organization{" "}
                      <span style={{ fontWeight: "bold" }}>FLAZ</span>.
                    </label>
                    <div className="">
                      {/* <button className='createbtn w-100' type='' style={{ fontSize: '15px', marginTop: '50px' }} onClick={() => { window.location.href = '/login' }}>Go to App</button> */}
                      <button
                        className="createbtn"
                        type=""
                        style={{
                          fontSize: "15px",
                          marginTop: "30px",
                          marginRight: "0px",
                        }}
                        onClick={() => {
                          window.location.href = "/admin/login";
                        }}
                      >
                        Go to App
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : (
          ""
        )}
      </>
    );
  }
}
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    VerifyInviteFromLink: state.userReducer.VerifyInviteFromLink,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SetPassword)
);
